import React, { useState } from 'react';
import { GlobalDataContext } from './GlobalDataContext';
import defaultConfig from '@config/defaultConfig';

/**
 * Wrapper to make a Provider for the GlobalDataContext.
 * @returns {React.Provider<GlobalDataContext>}
 */
const GlobalDataProvider = ({ children }) => {
    const [globalContext, setGlobalContext] = useState(defaultConfig);

    return (
        <GlobalDataContext.Provider value={{ globalContext, setGlobalContext }}>
            {children}
        </GlobalDataContext.Provider>
    );
};

export default GlobalDataProvider;
